var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.surveyResponse.complete)?_c('div',[_c('h1',[_vm._v("Survey Successfully Completed")]),_vm._v(" "),_c('survey-response',{attrs:{"pages":_vm.surveyResponse.formatted_response.pages}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }